import React from 'react';
import { motion } from 'framer-motion';
import { Users, Briefcase, Award, Star } from 'lucide-react';

const Stats: React.FC = () => {
    const stats = [
        { icon: <Briefcase size={40} />, count: "6,561+", label: "CV Créés" },
        { icon: <Users size={40} />, count: "600+", label: "Utilisateurs Heureux" },
        { icon: <Award size={40} />, count: "250+", label: "Recrutements Facilités" },
        { icon: <Star size={40} />, count: "1,001+", label: "Avis Positifs" },
    ];

    return (
        <section className="bg-[#0a1b45] py-20 text-white">
            <div className="container mx-auto px-4">
                <div className="flex flex-col md:flex-row justify-between items-center">
                    <div className="md:w-1/3 mb-10 md:mb-0">
                        <h4 className="text-blue-400 font-semibold uppercase tracking-wider mb-2">Nos Chiffres</h4>
                        <h2 className="text-4xl font-bold leading-tight">Nous propulsons <br /> Votre carrière</h2>
                    </div>

                    <div className="md:w-2/3 grid grid-cols-2 md:grid-cols-4 gap-8">
                        {stats.map((stat, index) => (
                            <motion.div
                                key={index}
                                initial={{ opacity: 0, scale: 0.5 }}
                                whileInView={{ opacity: 1, scale: 1 }}
                                viewport={{ once: true }}
                                transition={{ delay: index * 0.1 }}
                                className="flex flex-col items-center text-center group"
                            >
                                <div className="text-gray-400 mb-4 group-hover:text-blue-400 transition-colors">
                                    {stat.icon}
                                </div>
                                <div className="text-3xl font-bold mb-1">{stat.count}</div>
                                <div className="text-sm text-gray-400">{stat.label}</div>
                            </motion.div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Stats;
